import React from 'react';
import SearchContent from './SearchContent';
import { DynamicSearchSuggestion } from 'Client/redux/dynamicSearch/types';
import { LandingPageRedirectOptions } from 'Client/components/OneHeader/DynamicSearch/searchService';
import { useBellaSelector } from 'Client/redux/hooks';

export interface SearchProps {
    suggestions: DynamicSearchSuggestion[];
    landingRedirects?: LandingPageRedirectOptions;
}

const DynamicSearch: React.FC = () => {
    const landingRedirects = useBellaSelector(state => state.redirect.landingRedirects);
    const suggestions = useBellaSelector(state => state.dynamicSearchSuggestions.suggestions);
    return <SearchContent suggestions={suggestions} landingRedirects={landingRedirects} />;
};

export default DynamicSearch;
